module.exports = __webpack_public_path__ + "assets/howitworks.ed4c68f8.svg";